import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import LocalStorageUtil from "../utils/localStorageUtil";
import { storageKeys } from "../utils/constants";

class ApiService {
  private authToken: string;

  constructor(authToken: string = "") {
    this.authToken = authToken;
  }

  public setAuthToken(token: string) {
    this.authToken = token;
  }

  /**
   * Get the current auth token
   * 
   */
  private getAuthToken(): string {
    // Try to get token from localStorage
    const storedToken = LocalStorageUtil.getItem(storageKeys.authToken, "");
    if (storedToken) {
      return storedToken;
    }
    return this.authToken;
  }

  private async request<T>(config: AxiosRequestConfig): Promise<T | null> {
    try {
      const authToken = this.getAuthToken();
      
      const headers = {
        ...config.headers,
        Authorization: `Bearer ${authToken}`,
      };

      const response: AxiosResponse<T> = await axios({
        ...config,
        headers,
      });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error("API call failed:", error.message);
        return error.response?.data || null;
      } else {
        console.error("An unexpected error occurred:", error);
        return null;
      }
    }
  }

  public async get<T>(url: string, params?: any): Promise<T | null> {
    return this.request<T>({
      method: "GET",
      url,
      params: typeof params === "string" ? JSON.parse(params) : params,
    });
  }

  public async post<T>(url: string, data?: any): Promise<T | null> {
    return this.request<T>({
      method: "POST",
      url,
      data: typeof data === "string" ? JSON.parse(data) : data,
    });
  }

  public async put<T>(url: string, data?: object): Promise<T | null> {
    return this.request<T>({
      method: "PUT",
      url,
      data,
    });
  }

  public async delete<T>(url: string): Promise<T | null> {
    return this.request<T>({
      method: "DELETE",
      url,
    });
  }
}

const apiService = new ApiService();
export default apiService;
